// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"505c6105","219":"640d83e4","391":"6275a588","453":"97957904","781":"f9393d03","816":"7d1fc0eb","824":"90f718ba","838":"33463c9a","900":"48efaddc","912":"c8876717","958":"26b39769","997":"23e71dd1"}[chunkId] + ".chunk.js";
};